/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["stickers-drawer .button-with-image.dark-bg{background-color:rgba(0,0,0,.12)}"];
export { styles as styles };
